export default __webpack_public_path__ + "static/media/absolut.8feed491.svg";